// extracted by mini-css-extract-plugin
export var infoItem = "_n5-2";
export var title = "_n5-0";
export var value = "_n5-1";